import React, { useState } from "react";
import toast from "react-hot-toast";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/modal/email.svg";
import { ReactComponent as ContactIcon } from "../../../../assets/icons/supplier/contact.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/icons/supplier/phone.svg";

import { IClient } from "../../../../types/clients.type";
import { formatPhoneNumber } from "../../../../utils/fotmatPhoneNumber";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  client: IClient;
}

const EditClientForm: React.FC<Props> = (props) => {
  const [fullName, setFullName] = useState<string>(props.client.fullName);
  const [email, setEmail] = useState<string>(props.client.email);
  const [phone, setPhone] = useState<string>(
    formatPhoneNumber(props.client.phone)
  );
  // const [note, setNote] = useState<string>(props.client.note);

  const onChangePhone = (value: string) => {
    const formated = formatPhoneNumber(value);
    setPhone(formated);
  };

  const onClickApply = async () => {
    try {
      // const body: IClientCreateDto = {
      //   fullName,
      //   email,
      //   phone: unformatPhoneNumber(phone),
      //   // note,
      // };
      // const response = await authApiService.updateClient(props.client.id, body);
      // if (response) {
      //   props.onApply();
      // }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <EditInput
          value={fullName}
          setValue={setFullName}
          isRequired
          title="Імʼя та Прізвище"
        >
          <ContactIcon />
        </EditInput>

        <EditInput
          value={email}
          setValue={setEmail}
          title="Пошта"
          isRequired={false}
        >
          <EmailIcon />
        </EditInput>
        <EditInput
          value={phone}
          setValue={onChangePhone}
          title="Номер телефону"
          isRequired={false}
        >
          <PhoneIcon />
        </EditInput>

        {/* <EditInput
          value={note}
          setValue={setNote}
          title="Примітка"
          isRequired={false}
          isBig={true}
        /> */}
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        isDeleteBackButton={true}
        applyTitle="Зберегти"
        backTitle="Видалити"
      />
    </div>
  );
};

export default EditClientForm;
